import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class CaseService {
    constructor(private dataTask: DataTaskService) {}

    public getCase(params: CaseGetParams): Promise<CaseGet[]> {
        return this.dataTask.Post(2558, params);
    }

    public saveCase(page: CaseGet): Promise<CaseSaveResponse[]> {
        return this.dataTask.Post(2560, page);
    }
}

export interface CaseGetParams {
    case_keyno: string;
}

export interface CaseGet extends CaseGetParams {
    colli_content: string;
    volume_m3: string;
    weight_kg: string;
    reg_datetime: string;
    colli_dispatch_ean: string;
    printergroup_id: string;
    printerlocation_id: string;
    printer_id: string;
    report_id: string;
    [key: string]: string;
}

export interface CaseSaveResponse {
    errorcode: string;
    errormessage: string;
}
